import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Header component that displays the site name and tagline
 * Now clickable to navigate to the About page
 */
interface HeaderProps {
  siteName: string;
  tagline?: string;
}

const Header: React.FC<HeaderProps> = ({ siteName, tagline }) => {
  return (
    <header className="header">
      <Link to="/about" className="header-link">
        <h1>{siteName}</h1>
        {tagline && <p className="tagline">{tagline}</p>}
      </Link>
    </header>
  );
};

export default Header; 